export const merchandiseOrderEnum = [
  {
      stateId: "UNPAID",
      stateName: "待支付"
  },
  {
      stateId: "CANCELLED",
      stateName: "已取消"
  },
  {
      stateId: "CLOSED",
      stateName: "已关闭"
  },
  {
      stateId: "REGISTERED",
      stateName: "已报名"
  },
  {
      stateId: "IN_PROGRESS",
      stateName: "活动中"
  },
  {
      stateId: "REFUNDING",
      stateName: "退款中"
  },
  {
      stateId: "REFUNDED",
      stateName: "已退款"
  },
  {
      stateId: "COMPLETED",
      stateName: "已完成"
  },
  {
    stateId: "PARTIAL_REFUND",
    stateName: "部分退款"
  },
]